// inversify requirement
import "reflect-metadata";

export * from "@api/index";
